import React, { useMemo } from "react"
import styles from "./OpportunityArticle.module.scss"
import P from "prop-types"
import { Grid } from "@material-ui/core"
import draftToHtml from "draftjs-to-html"
import {
  beautifyDraftDescription,
  ensureHtmlLinksOpenInNewTab,
} from "../../../../helpers/textHelpers"

const OpportunityArticle = ({ data }) => {
  const htmlContent = useMemo(() => {
    if (!data || typeof data !== "string" || data.trim() === "") {
      return ""
    }

    try {
      const beautified = beautifyDraftDescription(data)
      const parsed =
        typeof beautified === "string" ? JSON.parse(beautified) : beautified
      return draftToHtml(parsed)
    } catch (error) {
      console.error(
        "Error parsing opportunity description JSON:",
        error,
        "Data:",
        data,
      )
      return ""
    }
  }, [data])

  const markup = useMemo(() => {
    if (!htmlContent) return ""

    const element = document.createElement("div")
    element.innerHTML = htmlContent
    ensureHtmlLinksOpenInNewTab(element)
    return element.innerHTML
  }, [htmlContent])

  if (!markup) return null

  return (
    <Grid
      component="div"
      container
      direction="column"
      className={styles.article}
    >
      <h5 className={styles.articleTitle}>Description</h5>

      <div
        className={styles.articleText}
        dangerouslySetInnerHTML={{
          __html: markup,
        }}
      />
    </Grid>
  )
}

OpportunityArticle.propTypes = {
  title: P.string,
  text: P.string,
}

OpportunityArticle.defaultProps = {
  title: "",
  text: "",
}

export default OpportunityArticle
